import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getFaqs, getPage } from './moduleAPI';

const initialState = {
  prevActive: 0,
  cardToggle: [],
  eventRow: 0,
  eventNumber: 0,
  status: 'idle',
  pages_data: null,
  banner_data: null
};

export const FAQsAsync = createAsyncThunk(
  'Faqs/getFAQs',
  async (index, ThunkAPI) => {
    const response = await getPage();
    return response;
  }
);

export const PagesAsync = createAsyncThunk(
  'Faqs/getPages',
  async (index, ThunkAPI) => {
    const response = await getFaqs();
    return response;
  }
);

export const cardToggleSlice = createSlice({
  name: 'toggle',
  initialState,
  reducers: {
    toggle: (state, action) => {
      var index = state.cardToggle.indexOf(true);
      if(index === action.payload){
        state.cardToggle[action.payload] = !state.cardToggle[action.payload];
        state.eventRow = parseInt(action.payload);
        state.eventNumber = null;
      }else{
        state.cardToggle[index] = false;
        state.cardToggle[action.payload] = !state.cardToggle[action.payload];
        state.eventRow = parseInt(action.payload);
        state.eventNumber = null;
      }
    },
    selectedRow: (state, action) => {
      state.eventRow = action.payload;
    },
    selectedNumber: (state, action) => {
      state.eventNumber = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(PagesAsync.pending, (state) => {
      state.status = 'loading';
    });
    builder.addCase(PagesAsync.rejected, (state) => {
      state.status = 'rejected';
    });
    builder.addCase(PagesAsync.fulfilled, (state, action) => {
      state.status = 'idle';
      state.cardToggle = [];
      state.pages_data = action.payload;
      state.pages_data = state.pages_data ? state.pages_data.categories : '';
      state.pages_data = state.pages_data ? state.pages_data.sort((a, b) => (a.sequence > b.sequence) ? 1 : -1) : '';
      state.pages_data.forEach(function(item, index){
        state.cardToggle.push(false);
      });

      if (action.payload && !action.payload.isSuccess) {
        alert(action.payload.message)
      }
    });
    builder.addCase(FAQsAsync.pending, (state) => {
      state.status = 'loading';
    });
    builder.addCase(FAQsAsync.rejected, (state) => {
      state.status = 'rejected';
    });
    builder.addCase(FAQsAsync.fulfilled, (state, action) => {
      state.status = 'idle';
      state.banner_data = action.payload;
      if (action.payload && !action.payload.isSuccess) {
        alert(action.payload.message)
      }
    });
  }
});

export const { toggle, selectedRow, selectedNumber } = cardToggleSlice.actions;
export const cardToggleArray = (state) => state.FaqCard.cardToggle;
export const eventNumber = (state) => state.FaqCard.eventNumber;
export const eventRow = (state) => state.FaqCard.eventRow;
export const pagesData = (state) => state.FaqCard.pages_data;
export const bannerData = (state) => state.FaqCard.banner_data;

export const initFAQ = (index) => (dispatch, getState) => {
  setTimeout(() => {
    if(index){
      dispatch(toggle(index - 1));
    }else{
      dispatch(toggle(-1));
    }
   
  }, 100);
 
};

export const activeFAQ = (row, index) => (dispatch, getState) => {
  dispatch(selectedRow(row));
  dispatch(selectedNumber(index));
};

export default cardToggleSlice.reducer;
